import { createSelector } from 'reselect';

const selectapplications = (state: any) => state.applications;


export const selectapplicationsCurrentItem = createSelector([selectapplications], (applications) => applications.current);

export const selectapplicationsListItems = createSelector([selectapplications], (applications) => applications.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectapplicationsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectapplicationsQueryItems = createSelector([selectapplications], (applications) => applications.query);

export const selectapplicationsCreatedItem = createSelector([selectapplications], (applications) => applications.create);

export const selectapplicationsUpdatedItem = createSelector([selectapplications], (applications) => applications.update);

export const selectapplicationsReadItem = createSelector([selectapplications], (applications) => applications.read);

export const selectapplicationsDeletedItem = createSelector([selectapplications], (applications) => applications.delete);

export const selectapplicationsSearchedItems = createSelector([selectapplications], (applications) => applications.search);

export const selectapplicationsItemsCount = createSelector([selectapplications], (applications) => applications.count);

export const selectapplicationsItemsFilter = createSelector([selectapplications], (applications) => applications.filter);